export const carpayPaymentEmailRoute = (orderId = ':order_id') => `/carpay/orders/${orderId}/payment-email`
